import { Flex, Grid, GridItem, HStack, Switch, Text, VStack } from "@chakra-ui/react";

import AddressDetails from "./addressDetails";
import { CommunicationDetailsForm } from "src/types/FormTypes";
import { InputControl } from "src/common/formConstants";
import { Regisration_Form_Labels_English } from "src/common/constants/englishLabels";
import { Regisration_Form_Labels_Hindi } from "src/common/constants/hindiLabels";

type CommunicationDetailsProps = {
    communicationDetailsValues: CommunicationDetailsForm;
    handleCommunicationDetailsChanged: (fieldName: string, value: string | boolean) => void;
    isCurrentFormValid: boolean;
}

const CommunicationDetails: React.FC<CommunicationDetailsProps> = (props: CommunicationDetailsProps) => {
    const { communicationDetailsValues, isCurrentFormValid, handleCommunicationDetailsChanged } = props

    return (
        <VStack w="100%">
            <Grid gap={[0, 10, 10]} w="100%" templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(2, 1fr)"]}>
                <GridItem>
                    <InputControl isDisabled={true} isMobileNumber={true} isNumber={true} length={10} isValidate={isCurrentFormValid} isMandatory={true} onChange={handleCommunicationDetailsChanged} name="mobileNumber" value={communicationDetailsValues?.mobileNumber || ""} placeholder="Enter your mobile number" hindiLabel={Regisration_Form_Labels_Hindi.MOBILE_NUMBER} englishLabel={Regisration_Form_Labels_English.MOBILE_NUMBER} />
                </GridItem>
                <GridItem>
                    <InputControl isMobileNumber={true} isNumber={true} length={10} onChange={handleCommunicationDetailsChanged} name="alternateMobileNumber" value={communicationDetailsValues?.alternateMobileNumber || ""} placeholder="Enter your alternate mobile number" hindiLabel={Regisration_Form_Labels_Hindi.ALTERNATE_MOBILE_NUMBER} englishLabel={Regisration_Form_Labels_English.ALTERNATE_MOBILE_NUMBER} />
                </GridItem>
                <GridItem>
                    <InputControl isDisabled={true} isEmailId={true} isValidate={isCurrentFormValid} isMandatory={true} onChange={handleCommunicationDetailsChanged} name="emailId" value={communicationDetailsValues?.emailId} placeholder="Enter your mail id" hindiLabel={Regisration_Form_Labels_Hindi.EMAIL_ID} englishLabel={Regisration_Form_Labels_English.EMAIL_ID} />
                </GridItem>
                <GridItem>
                    <InputControl isEmailId={true} onChange={handleCommunicationDetailsChanged} name="alternateEmailId" value={communicationDetailsValues?.alternateEmailId} placeholder="Enter your alternate mail id" hindiLabel={Regisration_Form_Labels_Hindi.ALTERNATE_EMAIL_ID} englishLabel={Regisration_Form_Labels_English.ALTERNATE_EMAIL_ID} />
                </GridItem>
            </Grid>
            <HStack w="100%" mt={6}>
                <Text fontSize={16} className="form-heading">CURRENT ADDRESS</Text>
            </HStack>
            <AddressDetails
                isPermanentAddressEnabled={false}
                communicationDetailsValues={communicationDetailsValues}
                handleCommunicationDetailsChanged={handleCommunicationDetailsChanged}
                isCurrentFormValid={isCurrentFormValid}
            />
            <Flex direction={["column", "column", "column", "row"]} w="100%" mt={6} gap={4} justifyContent="space-between">
                <Text fontSize={16} className="form-heading">PERMANENT ADDRESS</Text>
                <HStack>
                    <Text fontSize={16} className="form-heading">THIS IS MY PERMANENT ADDRESS</Text>
                    <Switch colorScheme="orange" isChecked={communicationDetailsValues.isPermanentAddressEnabled} onChange={(event) => handleCommunicationDetailsChanged("isPermanentAddressEnabled", event.target.checked)} />
                </HStack>
            </Flex>
            <AddressDetails
                isPermanentAddressEnabled={true}
                communicationDetailsValues={communicationDetailsValues}
                handleCommunicationDetailsChanged={handleCommunicationDetailsChanged}
                isCurrentFormValid={isCurrentFormValid}
            />
        </VStack>
    )
}

export default CommunicationDetails;